import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { Style } from '../../style';

export const grey230border = `1px solid ${CommonStyles.Colors.Grey230}`;

export const flowOverviewPaneHeaderStyle: Style = {
  fontWeight: 'bold',
  flex: 'none',
  height: CommonStyles.Sizes.XLargeSpace,
  padding: `${CommonStyles.Sizes.DefaultSpace}px ${CommonStyles.Sizes.MediumSpace}px`,
  boxSizing: 'border-box',
  borderBottom: grey230border,
  display: 'flex',
  alignItems: 'center',
  fontSize: CommonStyles.Sizes.LargeFontSize,
  color: CommonStyles.Colors.Grey51,
};
